import { render, staticRenderFns } from "./PushMessage.vue?vue&type=template&id=4da74aae&scoped=true&"
import script from "./PushMessage.vue?vue&type=script&lang=js&"
export * from "./PushMessage.vue?vue&type=script&lang=js&"
import style0 from "./PushMessage.vue?vue&type=style&index=0&id=4da74aae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da74aae",
  null
  
)

export default component.exports